import React, { useState } from 'react';
import { ListGroup, Accordion } from 'react-bootstrap';
import ModalTrigger from './ModalTrigger';
import MitreText from './MitreText';
import {
  postFindMitreRelationships,
  getMoreLikeThis,
  postDocsByIds,
} from '../../services';
import CveDocument from '../CveDocument/CveDocument';
import Loading from '../DocList/Loading';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import DocCard from '../DocList/DocCard';
library.add(fal);
const MitreAttackDoc = ({
  doc,
  preDoc,
  profilePrimary,
  profileSecondary,
  list,
  allTags,
  updateTagSet,
  activeTags,
}) => {
  const [contents, setContents] = useState();
  const [contentsState, setContentsState] = useState(0);
  const [moreLikeThis, setmoreLikeThis] = useState({});
  const [moreLikeThisState, setmoreLikeThisState] = useState(0);
  const [relationships, setRelationships] = useState([]);
  const [active, setActive] = useState([]);
  const docTypes = {
    'x-mitre-tactic': 'Mitre Tactic',
    'attack-pattern': 'Attack Pattern',
    'course-of-action': 'Course of Action',
    'intrusion-set': 'Intrusion Set',
    malware: 'Malware',
    tool: 'Tool',
    'x-mitre-data-source': 'Mitre Data Source',
    'x-mitre-data-component': 'Mitre Data Component',
    relationship: 'Relationship',
    identity: 'Identity',
  };
  const fields = [
    'title',
    'url',
    'text',
    'publishDate',
    'modified',
    'objectType',
    'x_mitre_aliases',
    'x_mitre_attack_spec_version',
    'x_mitre_platforms',
  ];
  useState(() => {
    if (typeof doc === 'string') {
      setContentsState(1);
      postDocsByIds(profilePrimary, [doc], fields).then((result) => {
        if (result.status === 200) {
          setContents(result.documents[0]);
          setContentsState(2);
          if (profilePrimary && profileSecondary) {
            setmoreLikeThisState(1);
            getMoreLikeThis(
              [contents.id],
              profilePrimary,
              profileSecondary
            ).then((finalResult) => {
              if (finalResult && finalResult.status === 200) {
                setmoreLikeThis(finalResult.documents);
                setmoreLikeThisState(0);
              } else {
                setmoreLikeThisState(0);
              }
            });
          }
        } else {
          setContents('<span>Unable to fetch document.</span>');
          setContentsState(2);
        }
      });
    }
  }, [doc]);

  const MoreCves = ({ data }) => {
    return (
      <div className='ctx-more-like-this ctx-more-cves'>
        <h3>
          Relevant CVE<span>s</span>
        </h3>
        <ListGroup variant='flush'>
          {Object.entries(data).map(([key, value]) => (
            <ListGroup.Item key={value.id}>
              <CveDocument cve={value} />
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>
    );
  };

  const MoreDocuments = ({ data }) => {
    return (
      <div className='ctx-more-like-this ctx-more-news'>
        {Object.entries(data).map(([key, doc]) => (
          <ListGroup.Item key={contents.id}>
            <DocCard
              doc={doc}
              showAddWatchList={profilePrimary.roles.indexOf('curator') > -1}
              list={list}
              showRemove={profilePrimary.roles.indexOf('curator') > -1}
              profilePrimary={profileSecondary}
              key={null}
              //allTags={searchOptions}
              //selectedTags={selectedSearchValue.map((t) => t.name)}
            />
          </ListGroup.Item>
        ))}
      </div>
    );
  };

  const tab0 = () => {
    postFindMitreRelationships(profilePrimary, contents.id, contents.id).then(
      (res) => {
        if (res.status === 200) {
          const docIds = res.documents.map((rel) => rel.target_ref);
          postDocsByIds(profilePrimary, docIds, fields).then((relDocs) => {
            setRelationships(relDocs.documents);
          });
        }
      }
    );
  };

  const toggleActive = (tabIndex) => {
    let cur = [...active];
    if (cur.indexOf(tabIndex) > -1) {
      cur.splice(cur.indexOf(tabIndex), 1);
    } else {
      cur = [...cur, tabIndex];
    }
    if (tabIndex === 0) {
      tab0();
    }
    setActive(cur);
  };

  return (
    <>
      {contents ? (
        <section className='ctx-card-readmore'>
          <h5>
            {contents.url ? (
              <a
                href={contents.url}
                target='_blank'
                rel='noreferrer'
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                {contents.title}
              </a>
            ) : (
              contents.title
            )}
          </h5>
          <div className='ctx-card-info'>
            <span className='ctx-field-group'>
              <span className='ctx-label'>Created On: </span>
              <span className='ctx-value'>{contents.publishDate}</span>
            </span>
            <span className='ctx-field-group'>
              <span className='ctx-label'>Updated On: </span>
              <span className='ctx-value'>{contents.modified}</span>
            </span>
            <span className='ctx-field-group'>
              <span className='ctx-label'>Type: </span>
              <span className='ctx-value ctx-source'>
                {docTypes[contents.objectType] || contents.objectType}
              </span>
            </span>
            {contents.x_mitre_platforms ? (
              <span className='ctx-field-group'>
                <span className='ctx-label'>Platforms: </span>
                <span className='ctx-value ctx-source'>
                  <ul>
                    {contents.x_mitre_platforms.map((platform) => (
                      <li>{platform}</li>
                    ))}
                  </ul>
                </span>
              </span>
            ) : null}
            {contents.text ? (
              <span className='ctx-field-group'>
                <span className='ctx-value ctx-source'>
                  <MitreText text={contents.text} />
                </span>
              </span>
            ) : null}
          </div>
          {contentsState ? (
            <div className='ctx-readmore-wrapper' style={{ marginTop: '30px' }}>
              <Accordion flush defaultActiveKey={active}>
                <Accordion.Item
                  eventKey='0'
                  onClick={(e, i) => toggleActive(0)}
                >
                  <Accordion.Header>References</Accordion.Header>
                  <Accordion.Body>
                    {relationships.length ? (
                      <ul className='mitre-external-refs'>
                        {relationships.map((ref) => (
                          <li key={ref.id}>
                            <h6 style={{ fontWeight: '600' }}>{ref.title}</h6>
                            {ref.text ? <MitreText text={ref.text} /> : null}
                            <ModalTrigger
                              doc={ref.id}
                              preDoc={ref}
                              profilePrimary={profilePrimary}
                            />
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <Loading />
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div className='ctx-more-card-info'>
                {contents.x_mitre_aliases && contents.x_mitre_aliases.length ? (
                  <span className='ctx-field-group'>
                    <span className='ctx-label'>Aliases: </span>
                    <span className='ctx-value'>
                      <ul className='mitre-external-refs'>
                        {contents.x_mitre_aliases.map((alias) => (
                          <li key={alias}>{alias}</li>
                        ))}
                      </ul>
                    </span>
                  </span>
                ) : null}
                {contents.external_references &&
                contents.external_references.length ? (
                  <span className='ctx-field-group'>
                    <span className='ctx-label'>External References: </span>
                    <span className='ctx-value'>
                      <ol className='mitre-external-refs'>
                        {contents.external_references.map((ref) => (
                          <li key={ref.id}>
                            {ref.description}
                            <span className='inner-label mitre-external-refs-source'>
                              <strong>Source:</strong>
                              {ref.url ? (
                                <a
                                  href={ref.url}
                                  target='_blank'
                                  rel='noreferrer'
                                >
                                  {ref.source_name}
                                </a>
                              ) : (
                                <span>{ref.source_name}</span>
                              )}
                            </span>
                          </li>
                        ))}
                      </ol>
                    </span>
                  </span>
                ) : null}
              </div>

              {contentsState === 1 && <Loading text='Retrieving More...' />}
              <div className='ctx-readmore-contents'>
              </div>
              {moreLikeThisState === 1 && (
                <Loading text='Finding Related Documents...' />
              )}
              {moreLikeThis && moreLikeThis.length ? (
                profileSecondary.type && profileSecondary.type === 'news' ? (
                  <MoreDocuments data={moreLikeThis} />
                ) : (
                  <MoreCves data={moreLikeThis} />
                )
              ) : null}
            </div>
          ) : null}
        </section>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default MitreAttackDoc;
